import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-cc2dcbf1.js';
import { m as marginPropTypes } from './spacing-7e57ffb0.js';
import { S as SvgIcon } from './SvgIcon-1308e965.js';

function IconPylon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.107 1.984c0 .197-.06.396-.185.569a4.86 4.86 0 0 0 0 5.698.973.973 0 0 1-.236 1.37 1.01 1.01 0 0 1-1.394-.231 6.8 6.8 0 0 1 0-7.976 1.01 1.01 0 0 1 1.394-.232.977.977 0 0 1 .421.802z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.458 8.464A3.902 3.902 0 0 1 8 5.426c0-2.173 1.79-3.934 4-3.934s4 1.761 4 3.934c0 1.27-.612 2.4-1.562 3.12l4.838 13.134a.98.98 0 0 1-.597 1.26 1.005 1.005 0 0 1-1.282-.588l-.22-.599-5.127-3.024-5.284 3.117a1.795 1.795 0 0 1-.138.074l-.16.432a1.002 1.002 0 0 1-1.28.588.98.98 0 0 1-.599-1.26L9.46 8.464zm3.413-1.278c.021-.008.043-.014.064-.02A1.963 1.963 0 0 0 14 5.426c0-1.086-.895-1.967-2-1.967s-2 .88-2 1.967c0 1.087.895 1.967 2 1.967.24 0 .472-.042.686-.118a1.01 1.01 0 0 1 .185-.089zM13.583 12l-.988-2.683a4.1 4.1 0 0 1-1.316-.02L10.283 12h3.3zm.737 2H9.546l-.289.783 2.793 1.648 2.6-1.534-.33-.897zm-.322 3.58 1.348-.795.748 2.032-2.096-1.237zm-6.292 1.413 2.396-1.413-1.54-.909-.856 2.322z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.922 3.203a.64.64 0 0 0 .185-.439c0-.237-.146-.472-.42-.62-.45-.243-1.075-.162-1.395.18-1.724 1.843-1.722 4.318 0 6.16.32.342.944.422 1.394.18.45-.244.557-.718.236-1.06-1.23-1.316-1.229-3.085 0-4.4zm9.971-.439c0 .152.06.306.185.44 1.229 1.315 1.23 3.084 0 4.4-.321.342-.213.816.236 1.06.45.242 1.074.162 1.394-.18 1.722-1.842 1.724-4.317 0-6.16-.32-.342-.944-.423-1.394-.18-.275.148-.421.383-.421.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.078 2.553a.968.968 0 0 1-.185-.569.98.98 0 0 1 .42-.802 1.01 1.01 0 0 1 1.395.232 6.8 6.8 0 0 1 0 7.976 1.01 1.01 0 0 1-1.394.232.973.973 0 0 1-.236-1.371 4.86 4.86 0 0 0 0-5.698z"
  }));
}
IconPylon.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconPylon.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconPylon as default };
